import React, { forwardRef } from 'react';

import InputTemplate from '../TemplateNumberFormatInput';

const PesoInput = forwardRef((props, ref) => (
  <InputTemplate {...props} escala={1} sufixo=" °C" ref={ref} />
));

export default PesoInput;
